import administracionDeContenidos from "./administracionDeContenidos/administracionDeContenidos"
import administracionDePermisos from "./administracionDePermisos/administracionDePermisos";
import paginaintranet from "./paginaIntranet/paginaIntranet"

const intranet = {
    administracionDeContenidos: administracionDeContenidos,
    administracionDePermisos: administracionDePermisos,
    paginaintranet: paginaintranet
};

export default intranet;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/intranet/intranet.js
// module id = null
// module chunks = 